import { render, staticRenderFns } from "./content-dialog.vue?vue&type=template&id=25380435&scoped=true"
import script from "./content-dialog.vue?vue&type=script&lang=js"
export * from "./content-dialog.vue?vue&type=script&lang=js"
import style0 from "./content-dialog.vue?vue&type=style&index=0&id=25380435&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25380435",
  null
  
)

export default component.exports